// Constructor
function AnimationEngine(app, game) {
	this.app = app;
	this.game = game;

	this.animationsContainer = false;
	this.activeAnimations = [];
	this.animationTweens = {};

	this.leavesColors = ["red", "orange", "dark-orange"];

	this.init();
}


AnimationEngine.prototype.init = function () {
	this.animationsContainer = $("#farmer-scene #animations-container");
};

AnimationEngine.prototype.initScene = function (scene) {

	// set all anims as not in use, we will delete later them if they are really not in use
	$.each(this.animationTweens, function (i, anim) {
		anim.inUse = false;
	});

	// setup animations
	$.each(scene.animations, $.proxy(function (i, anim) {
		switch (anim) {
			case "birds-v":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					var birds = $('<div class="animation birds-v"></div>');
					this.animationsContainer.append(birds);
					birds.html($('#graphics-bank svg[data-graphic-id="birds-v"]').clone());

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];
					this.animationTweens[anim].tweens.push(TweenMax.fromTo(birds, 60, {
						left: "-14%"
					}, {
						left: "104%",
						ease: Linear.easeNone,
						repeatDelay: 5,
						repeat: -1
					}));
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "falling-leaves":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					var density = 20;

					for (i = 0; i < density; i++) {
						var leaf = $('<div class="animation falling-leaves"></div>');
						this.animationsContainer.append(leaf);
						leaf.html($('#graphics-bank svg[data-graphic-id="leaf"]').clone());

						this.spawnLeafParticle(leaf, anim);
					}
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "snow":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					var density = 20;

					for (i = 0; i < density; i++) {
						var snow = $('<div class="animation snow"></div>');
						this.animationsContainer.append(snow);
						snow.html($('#graphics-bank svg[data-graphic-id="snow"]').clone());

						this.spawnSnowParticle(snow, anim);
					}
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "harvested-crop":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					var density = 9;

					for (i = 0; i < density; i++) {
						var crop = $('<div class="animation harvested-crop"></div>');
						this.animationsContainer.append(crop);
						crop.html($('#graphics-bank svg[data-graphic-id="harvested-crop"]').clone());

						this.spawnHarvestedCrop(crop, i, anim, density);
					}
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "crop-1":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					var density = 9;

					for (i = 0; i < density; i++) {
						var crop = $('<div class="animation crop-1"></div>');
						this.animationsContainer.append(crop);
						crop.html($('#graphics-bank svg[data-graphic-id="crop-1"]').clone());

						this.spawnCrop(crop, i, anim, density);
					}
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "weed-small":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					var density = 10;

					for (i = 0; i < density; i++) {

						var type = (i % 3) + 1;

						var weed = $('<div class="animation weed-small weed-type-' + type + '"></div>');
						this.animationsContainer.append(weed);
						weed.html($('#graphics-bank svg[data-graphic-id="weed-' + type + '-small"]').clone());

						this.spawnWeed(weed, i, anim, density, "small");
					}
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "weed-medium":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					var density = 10;

					for (i = 0; i < density; i++) {

						var type = (i % 3) + 1;

						var weed = $('<div class="animation weed-medium weed-type-' + type + '"></div>');
						this.animationsContainer.append(weed);
						weed.html($('#graphics-bank svg[data-graphic-id="weed-' + type + '-medium"]').clone());

						this.spawnWeed(weed, i, anim, density, "medium");
					}
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "weed-big":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					var density = 10;

					for (i = 0; i < density; i++) {

						var type = (i % 3) + 1;

						var weed = $('<div class="animation weed-big weed-type-' + type + '"></div>');
						this.animationsContainer.append(weed);
						weed.html($('#graphics-bank svg[data-graphic-id="weed-' + type + '-big"]').clone());

						this.spawnWeed(weed, i, anim, density, "big");
					}
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "bees":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					var density = 3;

					for (i = 0; i < density; i++) {

						path = 'bee-' + (i + 1);

						var bee = $('<div class="animation bees"></div>');
						this.animationsContainer.append(bee);
						bee.html($('#graphics-bank svg[data-graphic-id="bee"]').clone());

						this.spawnBee(bee, i, anim, density, path);
					}
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "butterflies":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					var density = 2;

					for (i = 0; i < density; i++) {

						path = 'butterfly-' + (i + 1);

						var butterfly = $('<div class="animation butterflies"></div>');
						this.animationsContainer.append(butterfly);
						butterfly.html($('#graphics-bank svg[data-graphic-id="butterfly"]').clone());

						this.spawnButterfly(butterfly, i, anim, density, path);
					}
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "tractor-6a-6c":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					this.animateTractor6a6c(anim);
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "tractor-7a-7c":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					this.animateTractor7a7c(anim);
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "tractor-7b":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					this.animateTractor7b(anim);
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "tractor-9a":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					this.animateTractor9a(anim);
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "screen-9b":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					this.animateScreen9b(anim);
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "screen-9d":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					this.animateScreen9d(anim);
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "tractor-9c":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					this.animateTractor9c(anim);
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "tractor-9e":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					this.animateTractor9e(anim);
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "tractor-9g":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					this.animateTractor9g(anim);
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "screen-10b":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					this.animateScreen10b(anim);
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "screen-10d":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					this.animateScreen10d(anim);
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "screen-10e":
				// only add animation if it doesn't already exist
				if ($.inArray(anim, this.activeAnimations) === -1) {
					this.activeAnimations.push(anim);

					this.animationTweens[anim] = {};
					this.animationTweens[anim].tweens = [];

					this.animateScreen10e(anim);
				}

				this.animationTweens[anim].inUse = true;
				break;

			case "no-main-anim-timeout":

				console.log("no-main-anim-timeout");

				requestTimeout($.proxy(function () {
					this.mainAnimationCompleted();
				}, this), 2000);

				break;

			case "no-main-anim-timeout-winter":

				console.log("no-main-anim-timeout-winter");

				requestTimeout($.proxy(function () {
					this.mainAnimationCompleted();
				}, this), 7000);

				break;
		}
	}, this));


	// clean up non-necessary animations
	$.each(this.animationTweens, $.proxy(function (i, anim) {

		if (!anim.inUse) {
			this.animationsContainer.find(".animation." + i + "").fadeOut("normal", $.proxy(function (i, anim) {

				for (var j = 0; j < anim.tweens.length; j++) {
					if (anim.tweens[j] instanceof Array) {
						$(anim.tweens[j]).each(function (i, e) {
							e.kill();
						});
					} else {
						anim.tweens[j].kill();
					}
				}

				this.animationTweens[i] = null;
				delete this.animationTweens[i];

				var index = this.activeAnimations.indexOf(i);
				if (index !== -1) {
					this.activeAnimations.splice(index, 1);
				}

				this.animationsContainer.find(".animation." + i + "").remove();
			}, this, i, anim));
		}
	}, this));
};

AnimationEngine.prototype.spawnLeafParticle = function (particle, anim) {

	var speed = 0.5,
		containerHeight = this.animationsContainer.height(),
		containerWidth = this.animationsContainer.width(),
		start = {
			yMin: -100,
			yMax: -100,
			xMin: 0,
			xMax: containerWidth,
			xVariationMin: -200,
			xVariationMax: 200,
			scaleMin: 0.4,
			scaleMax: 1
		},
		mid = {
			yMin: containerHeight * 0.3,
			yMax: containerHeight * 0.5,
			xMin: 0,
			xMax: containerWidth,
			scaleMin: 0.4,
			scaleMax: 1
		},
		end = {
			yMin: containerHeight + 50,
			yMax: containerHeight + 50,
			xMin: 0,
			xMax: containerWidth,
			scaleMin: 0.4,
			scaleMax: 1
		};


	for (var c = 0; c < this.leavesColors.length; c++) {
		particle.removeClass("leaf-" + this.leavesColors[c]);
	}
	var color = this.leavesColors[Math.floor(Math.random() * this.leavesColors.length)];
	particle.addClass("leaf-" + color);

	var wholeDuration = (10 / speed) * (0.7 + Math.random() * 0.4),
		delay = wholeDuration * Math.random(),
		partialDuration = (wholeDuration + 1) * (0.3 + Math.random() * 0.4);

	var baseX = window.randomInRange(start, "x");
	var baseRotation = window.getRandomInt(-75, 75);
	//set the starting values
	this.animationTweens[anim].tweens.push(TweenMax.set(particle, {
		y: window.randomInRange(start, "y"),
		x: baseX,
		scale: window.randomInRange(start, "scale"),
		rotation: baseRotation,
		transformOrigin: "50% 50%"
	}));

	//the y tween should be continuous and smooth the whole duration
	this.animationTweens[anim].tweens.push(TweenMax.to(particle, wholeDuration, {
		delay: delay,
		y: window.randomInRange(end, "y"),
		ease: Linear.easeNone
	}));


	var xVariation = baseX + window.randomInRange(start, "xVariation");
	//now tween the x independently so that it looks more randomized (rather than linking it with scale/opacity changes too)
	this.animationTweens[anim].tweens.push(TweenMax.to(particle, partialDuration, {
		delay: delay,
		x: xVariation,
		ease: Power1.easeOut
	}));

	xVariation = baseX + window.randomInRange(start, "xVariation");
	this.animationTweens[anim].tweens.push(TweenMax.to(particle, wholeDuration - partialDuration, {
		delay: partialDuration + delay,
		x: xVariation,
		ease: Power1.easeIn
	}));

	//now create some random scale and opacity changes
	partialDuration = wholeDuration * (0.5 + Math.random() * 0.3);
	this.animationTweens[anim].tweens.push(TweenMax.to(particle, partialDuration, {
		delay: delay,
		scale: window.randomInRange(mid, "scale"),
		ease: Linear.easeNone
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to(particle, wholeDuration - partialDuration, {
		delay: partialDuration + delay,
		scale: window.randomInRange(end, "scale"),
		ease: Linear.easeNone,
		onComplete: $.proxy(this.spawnLeafParticle, this),
		onCompleteParams: [particle, anim]
	}));

}

AnimationEngine.prototype.spawnSnowParticle = function (particle, anim) {

	var speed = 0.75,
		containerHeight = this.animationsContainer.height(),
		containerWidth = this.animationsContainer.width(),
		start = {
			yMin: -50,
			yMax: -50,
			xMin: 0,
			xMax: containerWidth,
			xVariationMin: -200,
			xVariationMax: 200,
			scaleMin: 0.33,
			scaleMax: 1
		},
		mid = {
			yMin: containerHeight * 0.3,
			yMax: containerHeight * 0.7,
			xMin: 0,
			xMax: containerWidth,
			scaleMin: 0.33,
			scaleMax: 1
		},
		end = {
			yMin: containerHeight + 50,
			yMax: containerHeight + 50,
			xMin: 0,
			xMax: containerWidth,
			scaleMin: 0.33,
			scaleMax: 1
		};


	var wholeDuration = (10 / speed) * (0.7 + Math.random() * 0.4),
		delay = wholeDuration * Math.random(),
		partialDuration = (wholeDuration + 1) * (0.3 + Math.random() * 0.4);

	var baseX = window.randomInRange(start, "x");
	var baseRotation = window.getRandomInt(-75, 75);
	//set the starting values
	this.animationTweens[anim].tweens.push(TweenMax.set(particle, {
		y: window.randomInRange(start, "y"),
		x: baseX,
		scale: window.randomInRange(start, "scale"),
		rotation: baseRotation,
		transformOrigin: "50% 50%"
	}));

	//the y tween should be continuous and smooth the whole duration
	this.animationTweens[anim].tweens.push(TweenMax.to(particle, wholeDuration, {
		delay: delay,
		y: window.randomInRange(end, "y"),
		ease: Linear.easeNone
	}));


	var xVariation = baseX + window.randomInRange(start, "xVariation");
	//now tween the x independently so that it looks more randomized (rather than linking it with scale/opacity changes too)
	this.animationTweens[anim].tweens.push(TweenMax.to(particle, partialDuration, {
		delay: delay,
		x: xVariation,
		ease: Power1.easeOut
	}));

	xVariation = baseX + window.randomInRange(start, "xVariation");
	this.animationTweens[anim].tweens.push(TweenMax.to(particle, wholeDuration - partialDuration, {
		delay: partialDuration + delay,
		x: xVariation,
		ease: Power1.easeIn
	}));

	//now create some random scale and opacity changes
	partialDuration = wholeDuration * (0.5 + Math.random() * 0.3);
	this.animationTweens[anim].tweens.push(TweenMax.to(particle, partialDuration, {
		delay: delay,
		scale: window.randomInRange(mid, "scale"),
		ease: Linear.easeNone
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to(particle, wholeDuration - partialDuration, {
		delay: partialDuration + delay,
		scale: window.randomInRange(end, "scale"),
		ease: Linear.easeNone,
		onComplete: $.proxy(this.spawnLeafParticle, this),
		onCompleteParams: [particle, anim]
	}));

}

AnimationEngine.prototype.spawnHarvestedCrop = function (particle, index, anim, density) {

	var speed = 0.5, // seconds
		delay = 0.1, // seconds
		containerHeight = this.animationsContainer.height(),
		containerWidth = this.animationsContainer.width();


	var baseX = 300 + (((containerWidth - 300) / density) * index);

	//set the starting values
	this.animationTweens[anim].tweens.push(TweenMax.set(particle, {
		x: baseX,
		scale: 0,
		transformOrigin: "50% bottom"
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(particle, speed, {
		delay: delay * index,
		scale: 1,
		ease: Back.easeOut
	}));

}

AnimationEngine.prototype.spawnCrop = function (particle, index, anim, density) {

	var speed = 0.5, // seconds
		delay = 0.1, // seconds
		containerHeight = this.animationsContainer.height(),
		containerWidth = this.animationsContainer.width();


	var baseX = 300 + (((containerWidth - 300) / density) * index);

	//set the starting values
	this.animationTweens[anim].tweens.push(TweenMax.set(particle, {
		x: baseX,
		scale: 0,
		transformOrigin: "50% bottom"
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(particle, speed, {
		delay: delay * index,
		scale: 1,
		ease: Back.easeOut
	}));

}

AnimationEngine.prototype.spawnWeed = function (particle, index, anim, density, type, noAnimate) {

	var speed = 0.5, // seconds
		delay = 0.1, // seconds
		containerHeight = this.animationsContainer.height(),
		containerWidth = this.animationsContainer.width();

	var positions = [];

	if (type == "small") {
		positions = [370, 500, 540, 765, 780, 910, 1150, 1180, 1270, 1306];
	} else if (type == "medium") {
		positions = [240, 355, 490, 610, 750, 870, 1000, 1130, 1260, 1376];
	}

	if (noAnimate) {
		//set the starting values
		this.animationTweens[anim].tweens.push(TweenMax.set(particle, {
			x: positions[index % density],
			scale: 1,
			transformOrigin: "50% bottom"
		}));
	} else {
		//set the starting values
		this.animationTweens[anim].tweens.push(TweenMax.set(particle, {
			x: positions[index % density],
			scale: 0,
			transformOrigin: "50% bottom"
		}));

		this.animationTweens[anim].tweens.push(TweenMax.to(particle, speed, {
			delay: delay * index,
			scale: 1,
			ease: Back.easeOut
		}));
	}

	return positions[index % density];
}

AnimationEngine.prototype.spawnSwathedCrop = function (particle, index, anim, density, type, noAnimate) {

	var speed = 0.5, // seconds
		delay = 0.1, // seconds
		containerHeight = this.animationsContainer.height(),
		containerWidth = this.animationsContainer.width();

	var positions = [];

	if (type == "small") {
		positions = [290, 410, 526, 665, 810, 920, 1060, 1140, 1300, 1306];
	} else if (type == "medium") {
		positions = [240, 355, 490, 610, 750, 870, 1000, 1130, 1260, 1376];
	} else if (type == "canola-only") {
		positions = [240, 360, 456, 615, 760, 890, 980, 1130, 1280, 1376];
	}

	if (noAnimate) {
		//set the starting values
		this.animationTweens[anim].tweens.push(TweenMax.set(particle, {
			x: positions[index % density],
			scale: 1,
			transformOrigin: "50% bottom"
		}));
	} else {
		//set the starting values
		this.animationTweens[anim].tweens.push(TweenMax.set(particle, {
			x: positions[index % density],
			scale: 0,
			transformOrigin: "50% bottom"
		}));

		this.animationTweens[anim].tweens.push(TweenMax.to(particle, speed, {
			delay: delay * index,
			scale: 1,
			ease: Back.easeOut
		}));
	}

	return positions[index % density];
}

AnimationEngine.prototype.spawnBee = function (particle, index, anim, density, path) {

	var delay = window.getRandomFloat(0.5, 3);
	var speed = 1;
	var flipY = false;

	var offset = {
		x: 0,
		y: 0
	};

	if (path == "bee-1") {
		speed = 20;
	} else if (path == "bee-2") {
		speed = 6;
	} else if (path == "bee-3") {
		speed = 13;
	}

	var pathEle = $('#animation-paths svg[data-animation-path-id="' + path + '"] path');
	var bezierCurve = this.getGSAPBezierFromSVG(pathEle, offset);

	if (path == "bee-1") {
		flipY = true;
	}
	if (path == "bee-3") {
		bezierCurve.reverse();
		flipY = true;
	}

	particle.data("scaleState", 1);

	//set the starting values
	this.animationTweens[anim].tweens.push(TweenMax.set(particle, {
		x: bezierCurve[0].x,
		y: bezierCurve[0].y,
		opacity: 0,
		scaleX: 1,
		scaleY: flipY == true ? -1 : 1,
		transformOrigin: "50% 50%"
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(particle, 1, {
		delay: delay,
		opacity: 1
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(particle, speed, {
		delay: delay - 0.5,
		bezier: {
			type: "cubic",
			values: bezierCurve,
			curviness: 1,
			autoRotate: true
		},
		repeat: -1,
		yoyo: true,
		onRepeat: $.proxy(function (particle) {
			var scale = particle.data("scaleState") * (-1);
			particle.data("scaleState", scale)

			if (this.animationTweens[anim].inUse) {
				this.animationTweens[anim].tweens.push(TweenMax.to(particle, 0.5, {
					scaleX: scale,
					ease: Quad.easeInOut
				}));
			}

		}, this, particle),
		ease: Sine.easeInOut
	}));


}

AnimationEngine.prototype.spawnButterfly = function (particle, index, anim, density, path) {

	var delay = window.getRandomFloat(0.5, 3);
	var speed = 1;
	var flipX = false;

	var offset = {
		x: 0,
		y: 0
	};

	if (path == "butterfly-1") {
		speed = 8;
		offset.x = 90;
		offset.y = -10;
	} else if (path == "butterfly-2") {
		speed = 13;
		offset.x = 35;
		offset.y = -20;
	}

	var pathEle = $('#animation-paths svg[data-animation-path-id="' + path + '"] path');
	var bezierCurve = this.getGSAPBezierFromSVG(pathEle, offset);

	if (path == "butterfly-2") {
		bezierCurve.reverse();
		flipX = true;
		particle.addClass("pink");
	}

	particle.data("scaleState", flipX == true ? -1 : 1);

	//set the starting values
	this.animationTweens[anim].tweens.push(TweenMax.set(particle, {
		x: bezierCurve[0].x,
		y: bezierCurve[0].y,
		opacity: 0,
		scaleX: flipX == true ? -1 : 1,
		scaleY: 1,
		transformOrigin: "50% 50%"
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(particle, 1, {
		delay: delay,
		opacity: 1
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(particle, speed, {
		delay: delay - 0.5,
		bezier: {
			type: "cubic",
			values: bezierCurve,
			curviness: 1,
			autoRotate: false
		},
		repeat: -1,
		yoyo: true,
		onRepeat: $.proxy(function (particle) {
			var scale = particle.data("scaleState") * (-1);
			particle.data("scaleState", scale)

			if (this.animationTweens[anim].inUse) {
				this.animationTweens[anim].tweens.push(TweenMax.to(particle, 0.5, {
					scaleX: scale,
					ease: Quad.easeInOut
				}));
			}

		}, this, particle),
		ease: Sine.easeInOut
	}));


}

AnimationEngine.prototype.animateTractor6a6c = function (anim) {

	var density = 9;

	for (var i = 0; i < density; i++) {

		// generate crops that will be animated on truck pass
		var crop = $('<div id="tractor-6a-6c-crop-' + i + '" class="animation tractor-6a-6c crop"></div>');
		this.animationsContainer.append(crop);
		crop.html($('#graphics-bank svg[data-graphic-id="harvested-crop"]').clone());

		var baseX = 300 + (((this.animationsContainer.width() - 300) / density) * i);

		//set the starting values
		this.animationTweens[anim].tweens.push(TweenMax.set(crop, {
			x: baseX,
			scale: 1,
			transformOrigin: "50% bottom"
		}));

		// generate soil that will be animated on truck pass
		var soil = $('<div id="tractor-6a-6c-soil-' + i + '" class="animation tractor-6a-6c soil"></div>');
		this.animationsContainer.append(soil);
		soil.html($('#graphics-bank svg[data-graphic-id="harvested-soil"]').clone());

		//set the starting values
		this.animationTweens[anim].tweens.push(TweenMax.set(soil, {
			x: baseX,
			autoAlpha: 0
		}));
	}

	// Animate truck passing from left to right, then right to left
	var truck = $('<div class="animation tractor-6a-6c truck"></div>');
	this.animationsContainer.append(truck);
	truck.html($('#graphics-bank svg[data-graphic-id="tractor-6a-6c-truck"]').clone());

	var truckWholeDuration = 20;

	this.animationTweens[anim].tweens.push(TweenMax.set(truck, {
		left: "-32%",
		scaleX: -1
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(truck, truckWholeDuration / 2, {
		left: "102%",
		ease: Linear.easeNone,
		onComplete: $.proxy(this.mainAnimationCompleted, this)
	}));

	// make the crops disapear and make soil show
	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-crop-0"), 0.2, {
		autoAlpha: 0,
		delay: 0.15 * truckWholeDuration
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-soil-0"), 0.2, {
		autoAlpha: 1,
		delay: 0.17 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-crop-1"), 0.2, {
		autoAlpha: 0,
		delay: 0.17 * truckWholeDuration
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-soil-1"), 0.2, {
		autoAlpha: 1,
		delay: 0.19 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-crop-2"), 0.2, {
		autoAlpha: 0,
		delay: 0.20 * truckWholeDuration
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-soil-2"), 0.2, {
		autoAlpha: 1,
		delay: 0.22 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-crop-3"), 0.2, {
		autoAlpha: 0,
		delay: 0.24 * truckWholeDuration
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-soil-3"), 0.2, {
		autoAlpha: 1,
		delay: 0.26 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-crop-4"), 0.2, {
		autoAlpha: 0,
		delay: 0.27 * truckWholeDuration
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-soil-4"), 0.2, {
		autoAlpha: 1,
		delay: 0.29 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-crop-5"), 0.2, {
		autoAlpha: 0,
		delay: 0.31 * truckWholeDuration
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-soil-5"), 0.2, {
		autoAlpha: 1,
		delay: 0.33 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-crop-6"), 0.2, {
		autoAlpha: 0,
		delay: 0.35 * truckWholeDuration
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-soil-6"), 0.2, {
		autoAlpha: 1,
		delay: 0.37 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-crop-7"), 0.2, {
		autoAlpha: 0,
		delay: 0.37 * truckWholeDuration
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-soil-7"), 0.2, {
		autoAlpha: 1,
		delay: 0.39 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-crop-8"), 0.2, {
		autoAlpha: 0,
		delay: 0.41 * truckWholeDuration
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-soil-8"), 0.2, {
		autoAlpha: 1,
		delay: 0.43 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-crop-6"), 0.2, {
	// 	autoAlpha: 0,
	// 	delay: 0.64 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-soil-6"), 0.2, {
	// 	autoAlpha: 1,
	// 	delay: 0.65 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-crop-5"), 0.2, {
	// 	autoAlpha: 0,
	// 	delay: 0.67 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-soil-5"), 0.2, {
	// 	autoAlpha: 1,
	// 	delay: 0.69 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-crop-3"), 0.2, {
	// 	autoAlpha: 0,
	// 	delay: 0.74 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-soil-3"), 0.2, {
	// 	autoAlpha: 1,
	// 	delay: 0.76 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-crop-2"), 0.2, {
	// 	autoAlpha: 0,
	// 	delay: 0.765 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-soil-2"), 0.2, {
	// 	autoAlpha: 1,
	// 	delay: 0.785 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-crop-0"), 0.2, {
	// 	autoAlpha: 0,
	// 	delay: 0.84 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-6a-6c-soil-0"), 0.2, {
	// 	autoAlpha: 1,
	// 	delay: 0.86 * truckWholeDuration
	// }));
}

AnimationEngine.prototype.animateTractor7a7c = function (anim) {

	var density = 9;

	for (var i = 0; i < density; i++) {
		// generate soil that will be animated on truck pass
		var soil = $('<div id="tractor-7a-7c-soil-' + i + '" class="animation tractor-7a-7c soil"></div>');
		this.animationsContainer.append(soil);
		soil.html($('#graphics-bank svg[data-graphic-id="harvested-soil"]').clone());

		var baseX = 300 + (((this.animationsContainer.width() - 300) / density) * i);

		//set the starting values
		this.animationTweens[anim].tweens.push(TweenMax.set(soil, {
			x: baseX,
			scaleY: 1,
			transformOrigin: "50% bottom"
		}));
	}

	// Animate truck passing from left to right, then right to left
	var truck = $('<div class="animation tractor-7a-7c truck"></div>');
	this.animationsContainer.append(truck);
	truck.html($('#graphics-bank svg[data-graphic-id="tractor-7a-7c-truck"]').clone());

	var truckWholeDuration = 20;

	this.animationTweens[anim].tweens.push(TweenMax.set(truck, {
		left: "-32%",
		scaleX: -1
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(truck, truckWholeDuration / 2, {
		left: "102%",
		ease: Linear.easeNone,
		// onComplete: $.proxy(function () {
		// 	this.animationTweens[anim].tweens.push(TweenMax.set(truck, {
		// 		scaleX: 1,
		// 	}));
		//
		// 	this.animationTweens[anim].tweens.push(TweenMax.to(truck, truckWholeDuration / 2, {
		// 		left: "-32%",
		// 		ease: Linear.easeNone,
		// 	}));
		// }, this)
	}));

	var halfFlat = 0;
	var flat = 0;

	// make soil half
	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7a-7c-soil-0"), 0.4, {
		scaleY: halfFlat,
		delay: 0.17 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7a-7c-soil-1"), 0.4, {
		scaleY: halfFlat,
		delay: 0.2 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7a-7c-soil-2"), 0.4, {
		scaleY: halfFlat,
		delay: 0.23 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7a-7c-soil-3"), 0.4, {
		scaleY: halfFlat,
		delay: 0.26 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7a-7c-soil-4"), 0.4, {
		scaleY: halfFlat,
		delay: 0.29 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7a-7c-soil-5"), 0.4, {
		scaleY: halfFlat,
		delay: 0.32 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7a-7c-soil-6"), 0.4, {
		scaleY: halfFlat,
		delay: 0.35 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7a-7c-soil-7"), 0.4, {
		scaleY: halfFlat,
		delay: 0.38 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7a-7c-soil-8"), 0.4, {
		scaleY: halfFlat,
		delay: 0.41 * truckWholeDuration
	}));

	//
	// // make soil flat
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7a-7c-soil-8"), 0.4, {
	// 	scaleY: flat,
	// 	delay: 0.60 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7a-7c-soil-7"), 0.4, {
	// 	scaleY: flat,
	// 	delay: 0.63 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7a-7c-soil-6"), 0.4, {
	// 	scaleY: flat,
	// 	delay: 0.66 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7a-7c-soil-5"), 0.4, {
	// 	scaleY: flat,
	// 	delay: 0.70 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7a-7c-soil-4"), 0.4, {
	// 	scaleY: flat,
	// 	delay: 0.73 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7a-7c-soil-3"), 0.4, {
	// 	scaleY: flat,
	// 	delay: 0.76 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7a-7c-soil-2"), 0.4, {
	// 	scaleY: flat,
	// 	delay: 0.79 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7a-7c-soil-1"), 0.4, {
	// 	scaleY: flat,
	// 	delay: 0.82 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7a-7c-soil-0"), 0.4, {
	// 	scaleY: flat,
	// 	delay: 0.85 * truckWholeDuration
	// }));


	// Animate second truck passing from left to right
	var truck2 = $('<div class="animation tractor-7a-7c truck-2"></div>');
	this.animationsContainer.append(truck2);
	truck2.html($('#graphics-bank svg[data-graphic-id="tractor-7a-7c-truck-2"]').clone());

	var truck2WholeDuration = 10;

	this.animationTweens[anim].tweens.push(TweenMax.set(truck2, {
		left: "-20%",
		scaleX: -1
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(truck2, truck2WholeDuration, {
		left: "102%",
		ease: Linear.easeNone,
		delay: (truckWholeDuration / 2) + 1,
		onComplete: $.proxy(this.mainAnimationCompleted, this)
	}));
}

AnimationEngine.prototype.animateTractor7b = function (anim) {

	var density = 9;

	for (var i = 0; i < density; i++) {
		// generate crops that will be animated on truck pass
		var crop = $('<div id="tractor-7b-crop-' + i + '" class="animation tractor-7b crop"></div>');
		this.animationsContainer.append(crop);
		crop.html($('#graphics-bank svg[data-graphic-id="harvested-crop"]').clone());

		var baseX = 300 + (((this.animationsContainer.width() - 300) / density) * i);

		//set the starting values
		this.animationTweens[anim].tweens.push(TweenMax.set(crop, {
			x: baseX,
			scale: 1,
			transformOrigin: "50% bottom"
		}));

		// generate soil that will be animated on truck pass
		var soil = $('<div id="tractor-7b-soil-' + i + '" class="animation tractor-7b soil"></div>');
		this.animationsContainer.append(soil);
		soil.html($('#graphics-bank svg[data-graphic-id="harvested-soil"]').clone());

		var baseX = 300 + (((this.animationsContainer.width() - 300) / density) * i);

		//set the starting values
		this.animationTweens[anim].tweens.push(TweenMax.set(soil, {
			x: baseX,
			scaleY: 1,
			transformOrigin: "50% bottom",
			autoAlpha: 0
		}));
	}

	// Animate truck passing from left to right, then right to left
	var truck = $('<div class="animation tractor-7b truck"></div>');
	this.animationsContainer.append(truck);
	truck.html($('#graphics-bank svg[data-graphic-id="tractor-7a-7c-truck-2"]').clone());

	var truckWholeDuration = 20;

	this.animationTweens[anim].tweens.push(TweenMax.set(truck, {
		left: "-20%",
		scaleX: -1
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(truck, truckWholeDuration / 2, {
		left: "102%",
		ease: Linear.easeNone,
		onComplete: $.proxy(this.mainAnimationCompleted, this)
	}));

	var flat = 0;
	var cropDisapearSpeed = 0.4;
	var soilDisapearSpeed = 0.8;

	// make the crops disapear and make soil show
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-crop-0"), cropDisapearSpeed, {
	// 	autoAlpha: 0,
	// 	delay: 0.15 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-0"), cropDisapearSpeed, {
	// 	autoAlpha: 1,
	// 	delay: 0.17 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-0"), soilDisapearSpeed, {
	// 	scaleY: flat,
	// 	delay: 0.20 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-crop-1"), cropDisapearSpeed, {
	// 	autoAlpha: 0,
	// 	delay: 0.18 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-1"), cropDisapearSpeed, {
	// 	autoAlpha: 1,
	// 	delay: 0.19 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-1"), soilDisapearSpeed, {
	// 	scaleY: flat,
	// 	delay: 0.22 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-crop-2"), cropDisapearSpeed, {
	// 	autoAlpha: 0,
	// 	delay: 0.21 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-2"), cropDisapearSpeed, {
	// 	autoAlpha: 1,
	// 	delay: 0.23 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-2"), soilDisapearSpeed, {
	// 	scaleY: flat,
	// 	delay: 0.26 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-crop-3"), cropDisapearSpeed, {
	// 	autoAlpha: 0,
	// 	delay: 0.24 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-3"), cropDisapearSpeed, {
	// 	autoAlpha: 1,
	// 	delay: 0.26 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-3"), soilDisapearSpeed, {
	// 	scaleY: flat,
	// 	delay: 0.29 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-crop-4"), cropDisapearSpeed, {
	// 	autoAlpha: 0,
	// 	delay: 0.28 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-4"), cropDisapearSpeed, {
	// 	autoAlpha: 1,
	// 	delay: 0.30 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-4"), soilDisapearSpeed, {
	// 	scaleY: flat,
	// 	delay: 0.33 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-crop-5"), cropDisapearSpeed, {
	// 	autoAlpha: 0,
	// 	delay: 0.31 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-5"), cropDisapearSpeed, {
	// 	autoAlpha: 1,
	// 	delay: 0.33 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-5"), soilDisapearSpeed, {
	// 	scaleY: flat,
	// 	delay: 0.36 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-crop-6"), cropDisapearSpeed, {
	// 	autoAlpha: 0,
	// 	delay: 0.34 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-6"), cropDisapearSpeed, {
	// 	autoAlpha: 1,
	// 	delay: 0.36 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-6"), soilDisapearSpeed, {
	// 	scaleY: flat,
	// 	delay: 0.38 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-crop-7"), cropDisapearSpeed, {
	// 	autoAlpha: 0,
	// 	delay: 0.37 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-7"), cropDisapearSpeed, {
	// 	autoAlpha: 1,
	// 	delay: 0.39 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-7"), soilDisapearSpeed, {
	// 	scaleY: flat,
	// 	delay: 0.42 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-crop-8"), cropDisapearSpeed, {
	// 	autoAlpha: 0,
	// 	delay: 0.40 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-8"), cropDisapearSpeed, {
	// 	autoAlpha: 1,
	// 	delay: 0.42 * truckWholeDuration
	// }));
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-8"), soilDisapearSpeed, {
	// 	scaleY: flat,
	// 	delay: 0.45 * truckWholeDuration
	// }));

	// // make soil flat
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-8"), soilDisapearSpeed, {
	// 	scaleY: flat,
	// 	delay: 0.60 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-7"), soilDisapearSpeed, {
	// 	scaleY: flat,
	// 	delay: 0.63 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-6"), soilDisapearSpeed, {
	// 	scaleY: flat,
	// 	delay: 0.66 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-5"), soilDisapearSpeed, {
	// 	scaleY: flat,
	// 	delay: 0.70 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-4"), soilDisapearSpeed, {
	// 	scaleY: flat,
	// 	delay: 0.73 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-3"), soilDisapearSpeed, {
	// 	scaleY: flat,
	// 	delay: 0.76 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-2"), soilDisapearSpeed, {
	// 	scaleY: flat,
	// 	delay: 0.79 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-1"), soilDisapearSpeed, {
	// 	scaleY: flat,
	// 	delay: 0.82 * truckWholeDuration
	// }));
	//
	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-7b-soil-0"), soilDisapearSpeed, {
	// 	scaleY: flat,
	// 	delay: 0.85 * truckWholeDuration
	// }));

}

AnimationEngine.prototype.animateTractor9a = function (anim) {

	var density = 9;

	for (var i = 0; i < density; i++) {
		// generate crops that will be animated on truck pass
		var crop = $('<div id="tractor-9a-crop-' + i + '" class="animation tractor-9a crop"></div>');
		this.animationsContainer.append(crop);
		crop.html($('#graphics-bank svg[data-graphic-id="crop-1"]').clone());

		var baseX = 300 + (((this.animationsContainer.width() - 300) / density) * i);

		//set the starting values
		this.animationTweens[anim].tweens.push(TweenMax.set(crop, {
			x: baseX,
			scale: 1,
			opacity: 1,
			transformOrigin: "50% bottom"
		}));

		// var fume = $('<div id="tractor-9a-fume-' + i + '" class="animation tractor-9a fumes"></div>');
		// this.animationsContainer.append(fume);
		// fume.html($('#graphics-bank svg[data-graphic-id="fumes"]').clone());
		//
		// //set the starting values
		// this.animationTweens[anim].tweens.push(TweenMax.set(fume, {
		// 	x: baseX,
		// 	y: "0%",
		// 	scale: 1,
		// 	autoAlpha: 0,
		// 	transformOrigin: "50% bottom"
		// }));
	}

	var density = 10;

	for (i = 0; i < density; i++) {

		var type = (i % 3) + 1;

		var weed = $('<div id="tractor-9a-weed-' + i + '" class="animation tractor-9a weed weed-type-' + type + '"></div>');
		this.animationsContainer.append(weed);
		weed.html($('#graphics-bank svg[data-graphic-id="weed-' + type + '-small"]').clone());

		this.spawnWeed(weed, i, anim, density, "small", true);
	}

	// Animate truck passing from left to right, then right to left
	var truck = $('<div class="animation tractor-9a truck"></div>');
	this.animationsContainer.append(truck);
	truck.html($('#graphics-bank svg[data-graphic-id="tractor-sprayer"]').clone());

	var truckWholeDuration = 10;

	this.animationTweens[anim].tweens.push(TweenMax.set(truck, {
		left: "-32%"
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(truck, truckWholeDuration, {
		left: "102%",
		ease: Linear.easeNone,
		onComplete: $.proxy(this.mainAnimationCompleted, this)
	}));

	var fumeAnimSpeed = 4;

	// make the crops disapear and make soil show
	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-crop-0"), {
		className: "+=die",
		delay: 0.38 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9a-fume-0"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.38 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9a-fume-0"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-weed-0"), {
		className: "+=die",
		delay: 0.40 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-crop-1"), {
		className: "+=die",
		delay: 0.44 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9a-fume-1"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.44 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9a-fume-1"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-weed-1"), {
		className: "+=die",
		delay: 0.46 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-crop-2"), {
		className: "+=die",
		delay: 0.50 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9a-fume-2"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.50 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9a-fume-2"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone,
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-weed-2"), {
		className: "+=die",
		delay: 0.50 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-crop-3"), {
		className: "+=die",
		delay: 0.56 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9a-fume-3"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.56 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9a-fume-3"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-weed-3"), {
		className: "+=die",
		delay: 0.5 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-crop-4"), {
		className: "+=die",
		delay: 0.64 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9a-fume-4"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.64 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9a-fume-4"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-weed-4"), {
		className: "+=die",
		delay: 0.63 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-crop-5"), {
		className: "+=die",
		delay: 0.70 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9a-fume-5"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.70 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9a-fume-5"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-weed-5"), {
		className: "+=die",
		delay: 0.70 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-crop-6"), {
		className: "+=die",
		delay: 0.76 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9a-fume-6"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.76 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9a-fume-6"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-weed-6"), {
		className: "+=die",
		delay: 0.76 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-crop-7"), {
		className: "+=die",
		delay: 0.82 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9a-fume-7"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.82 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9a-fume-7"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-weed-7"), {
		className: "+=die",
		delay: 0.82 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-crop-8"), {
		className: "+=die",
		delay: 0.88 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9a-fume-8"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.88 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9a-fume-8"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-weed-8"), {
		className: "+=die",
		delay: 0.88 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9a-weed-9"), {
		className: "+=die",
		delay: 0.90 * truckWholeDuration
	}));

}

AnimationEngine.prototype.animateScreen9b = function (anim) {

	var density = 9;

	for (var i = 0; i < density; i++) {
		var type = (i % 3) + 1;

		// generate crops that will be animated on truck pass
		var canola = $('<div id="screen-9b-canola-' + i + '" class="animation screen-9b canola canola-type-' + type + '"></div>');
		this.animationsContainer.append(canola);
		canola.html($('#graphics-bank svg[data-graphic-id="canola-plant"]').clone());

		var baseX = 300 + (((this.animationsContainer.width() - 300) / density) * i);

		//set the starting values
		this.animationTweens[anim].tweens.push(TweenMax.set(canola, {
			x: baseX,
			scale: 1,
			opacity: 1,
			transformOrigin: "50% bottom"
		}));

		this.animationTweens[anim].tweens.push(TweenMax.set(canola.find(".flower"), {
			scale: 0,
			transformOrigin: "center center"
		}));
	}

	var density = 10;

	for (i = 0; i < density; i++) {

		var type = (i % 3) + 1;

		var weed = $('<div id="screen-9b-weed-' + i + '" class="animation screen-9b weed weed-type-' + type + '"></div>');
		this.animationsContainer.append(weed);
		weed.html($('#graphics-bank svg[data-graphic-id="weed-' + type + '-small"]').clone());

		this.spawnWeed(weed, i, anim, density, "small", true);
	}

	var growSpeed = 1;

	// grow weeds
	this.animationTweens[anim].tweens.push(TweenMax.staggerTo($(".screen-9b.weed"), growSpeed, {
		scale: 3.25,
		delay: 0.5
	}, 0.2));

	// grow canola
	this.animationTweens[anim].tweens.push(TweenMax.staggerTo($(".screen-9b.canola"), growSpeed, {
		scale: 1.25,
		delay: 0.25
	}, 0.2, $.proxy(function () {

		var flowers = $(".screen-9b.canola:eq(0), .screen-9b.canola:eq(2), .screen-9b.canola:eq(3), .screen-9b.canola:eq(6), .screen-9b.canola:eq(8)").find(".flower");
		// grow flowers
		this.animationTweens[anim].tweens.push(TweenMax.staggerTo(flowers, growSpeed / 2, {
			scale: 2,
			delay: 0.25, // fixes overflow issue
			ease: Back.easeOut
		}, 0.1, $.proxy(this.mainAnimationCompleted, this)));
	}, this)));
}

AnimationEngine.prototype.animateScreen9d = function (anim) {

	var density = 9;

	for (var i = 0; i < density; i++) {
		var type = (i % 3) + 1;

		// generate crops that will be animated on truck pass
		var canola = $('<div id="screen-9d-canola-' + i + '" class="animation screen-9d canola canola-type-' + type + '"></div>');
		this.animationsContainer.append(canola);
		canola.html($('#graphics-bank svg[data-graphic-id="canola-plant"]').clone());

		var baseX = 300 + (((this.animationsContainer.width() - 300) / density) * i);

		//set the starting values
		this.animationTweens[anim].tweens.push(TweenMax.set(canola, {
			x: baseX,
			scale: 1,
			opacity: 1,
			transformOrigin: "50% bottom"
		}));

		this.animationTweens[anim].tweens.push(TweenMax.set(canola.find(".flower"), {
			scale: 0,
			transformOrigin: "center center"
		}));
	}

	var density = 10;

	for (i = 0; i < density; i++) {

		var type = (i % 3) + 1;

		var weed = $('<div id="screen-9d-weed-' + i + '" class="animation screen-9d weed weed-type-' + type + '"></div>');
		this.animationsContainer.append(weed);
		weed.html($('#graphics-bank svg[data-graphic-id="weed-' + type + '-medium"]').clone());

		this.spawnWeed(weed, i, anim, density, "medium", true);
	}

	var growSpeed = 1;

	// grow weeds
	this.animationTweens[anim].tweens.push(TweenMax.staggerTo($(".screen-9d.weed"), growSpeed, {
		scale: 2.25,
		delay: 0.5
	}, 0.2));

	// grow canola
	this.animationTweens[anim].tweens.push(TweenMax.staggerTo($(".screen-9d.canola"), growSpeed, {
		scale: 1.25,
		delay: 0.25
	}, 0.2, $.proxy(function () {

		var flowers = $(".screen-9d.canola:eq(0), .screen-9d.canola:eq(2), .screen-9d.canola:eq(3), .screen-9d.canola:eq(6), .screen-9d.canola:eq(8)").find(".flower");
		// grow flowers
		this.animationTweens[anim].tweens.push(TweenMax.staggerTo(flowers, growSpeed / 2, {
			scale: 2,
			delay: 0.25, // fixes overflow issue
			ease: Back.easeOut
		}, 0.1, $.proxy(this.mainAnimationCompleted, this)));
	}, this)));
}

AnimationEngine.prototype.animateTractor9c = function (anim) {

	var density = 9;

	for (var i = 0; i < density; i++) {
		// generate crops that will be animated on truck pass
		var crop = $('<div id="tractor-9c-crop-' + i + '" class="animation tractor-9c crop"></div>');
		this.animationsContainer.append(crop);
		crop.html($('#graphics-bank svg[data-graphic-id="crop-1"]').clone());

		var baseX = 300 + (((this.animationsContainer.width() - 300) / density) * i);

		//set the starting values
		this.animationTweens[anim].tweens.push(TweenMax.set(crop, {
			x: baseX,
			scale: 1,
			opacity: 1,
			transformOrigin: "50% bottom"
		}));

		// var fume = $('<div id="tractor-9c-fume-' + i + '" class="animation tractor-9c fumes"></div>');
		// this.animationsContainer.append(fume);
		// fume.html($('#graphics-bank svg[data-graphic-id="fumes"]').clone());

		// //set the starting values
		// this.animationTweens[anim].tweens.push(TweenMax.set(fume, {
		// 	x: baseX,
		// 	y: "0%",
		// 	scale: 1,
		// 	autoAlpha: 0,
		// 	transformOrigin: "50% bottom"
		// }));
	}

	var density = 10;

	for (i = 0; i < density; i++) {

		var type = (i % 3) + 1;

		var weed = $('<div id="tractor-9c-weed-' + i + '" class="animation tractor-9c weed weed-type-' + type + '"></div>');
		this.animationsContainer.append(weed);
		weed.html($('#graphics-bank svg[data-graphic-id="weed-' + type + '-medium"]').clone());

		this.spawnWeed(weed, i, anim, density, "medium", true);
	}

	// Animate truck passing from left to right, then right to left
	var truck = $('<div class="animation tractor-9c truck"></div>');
	this.animationsContainer.append(truck);
	truck.html($('#graphics-bank svg[data-graphic-id="tractor-sprayer"]').clone());

	var truckWholeDuration = 10;

	this.animationTweens[anim].tweens.push(TweenMax.set(truck, {
		left: "-32%"
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(truck, truckWholeDuration, {
		left: "102%",
		ease: Linear.easeNone,
		onComplete: $.proxy(this.mainAnimationCompleted, this)
	}));

	var fumeAnimSpeed = 4;

	// make the crops disapear and make soil show
	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-crop-0"), {
		className: "+=die",
		delay: 0.38 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9c-fume-0"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.38 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9c-fume-0"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-weed-0"), {
		className: "+=die",
		delay: 0.40 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-crop-1"), {
		className: "+=die",
		delay: 0.44 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9c-fume-1"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.44 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9c-fume-1"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-weed-1"), {
		className: "+=die",
		delay: 0.46 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-crop-2"), {
		className: "+=die",
		delay: 0.50 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9c-fume-2"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.50 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9c-fume-2"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone,
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-weed-2"), {
		className: "+=die",
		delay: 0.50 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-crop-3"), {
		className: "+=die",
		delay: 0.56 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9c-fume-3"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.56 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9c-fume-3"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-weed-3"), {
		className: "+=die",
		delay: 0.5 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-crop-4"), {
		className: "+=die",
		delay: 0.64 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9c-fume-4"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.64 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9c-fume-4"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-weed-4"), {
		className: "+=die",
		delay: 0.63 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-crop-5"), {
		className: "+=die",
		delay: 0.70 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9c-fume-5"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.70 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9c-fume-5"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-weed-5"), {
		className: "+=die",
		delay: 0.70 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-crop-6"), {
		className: "+=die",
		delay: 0.76 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9c-fume-6"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.76 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9c-fume-6"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-weed-6"), {
		className: "+=die",
		delay: 0.76 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-crop-7"), {
		className: "+=die",
		delay: 0.82 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9c-fume-7"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.82 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9c-fume-7"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-weed-7"), {
		className: "+=die",
		delay: 0.82 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-crop-8"), {
		className: "+=die",
		delay: 0.88 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9c-fume-8"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.88 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9c-fume-8"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-weed-8"), {
		className: "+=die",
		delay: 0.88 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9c-weed-9"), {
		className: "+=die",
		delay: 0.90 * truckWholeDuration
	}));

}

AnimationEngine.prototype.animateTractor9e = function (anim) {

	var density = 9;

	for (var i = 0; i < density; i++) {

		// generate crops that will be animated on truck pass
		var canola = $('<div id="tractor-9e-canola-' + i + '" class="animation tractor-9e canola"></div>');
		this.animationsContainer.append(canola);
		canola.html($('#graphics-bank svg[data-graphic-id="canola-plant"]').clone());

		var baseX = 300 + (((this.animationsContainer.width() - 300) / density) * i);

		//set the starting values
		this.animationTweens[anim].tweens.push(TweenMax.set(canola, {
			x: baseX,
			scale: 1,
			opacity: 1,
			transformOrigin: "50% bottom"
		}));

		this.animationTweens[anim].tweens.push(TweenMax.set(canola.find(".flower"), {
			scale: 0,
			transformOrigin: "center center"
		}));
	}

	var density = 10;

	for (i = 0; i < density; i++) {

		var type = (i % 3) + 1;

		var weed = $('<div id="tractor-9e-weed-' + i + '" class="animation tractor-9e weed weed-type-' + type + '"></div>');
		this.animationsContainer.append(weed);
		weed.html($('#graphics-bank svg[data-graphic-id="weed-' + type + '-small"]').clone());

		var xPos = this.spawnWeed(weed, i, anim, density, "small", true);

		// var fume = $('<div id="tractor-9e-fume-' + i + '" class="animation tractor-9e fumes"></div>');
		// this.animationsContainer.append(fume);
		// fume.html($('#graphics-bank svg[data-graphic-id="fumes"]').clone());

		// //set the starting values
		// this.animationTweens[anim].tweens.push(TweenMax.set(fume, {
		// 	x: xPos - 25,
		// 	y: "0%",
		// 	scale: 1,
		// 	autoAlpha: 0,
		// 	transformOrigin: "50% bottom"
		// }));
	}

	// Animate truck passing from left to right, then right to left
	var truck = $('<div class="animation tractor-9e truck"></div>');
	this.animationsContainer.append(truck);
	truck.html($('#graphics-bank svg[data-graphic-id="tractor-sprayer"]').clone());

	var truckWholeDuration = 10;

	this.animationTweens[anim].tweens.push(TweenMax.set(truck, {
		left: "-32%"
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(truck, truckWholeDuration, {
		left: "102%",
		ease: Linear.easeNone
	}));

	var fumeAnimSpeed = 4;


	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-0"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.38 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-0"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9e-weed-0"), {
		className: "+=die",
		delay: 0.40 * truckWholeDuration
	}));


	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-1"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.44 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-1"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9e-weed-1"), {
		className: "+=die",
		delay: 0.46 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-2"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.50 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-2"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone,
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9e-weed-2"), {
		className: "+=die",
		delay: 0.50 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-3"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.60 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-3"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9e-weed-3"), {
		className: "+=die",
		delay: 0.59 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-4"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.64 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-4"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9e-weed-4"), {
		className: "+=die",
		delay: 0.63 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-5"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.70 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-5"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9e-weed-5"), {
		className: "+=die",
		delay: 0.70 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-6"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.76 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-6"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9e-weed-6"), {
		className: "+=die",
		delay: 0.76 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-7"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.82 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-7"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9e-weed-7"), {
		className: "+=die",
		delay: 0.82 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-8"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.88 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-8"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9e-weed-8"), {
		className: "+=die",
		delay: 0.88 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9e-weed-9"), {
		className: "+=die",
		delay: 0.90 * truckWholeDuration
	}));


	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-9"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.90 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9e-fume-9"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));


	// grow canola
	var growSpeed = 1;

	this.animationTweens[anim].tweens.push(TweenMax.staggerTo($(".tractor-9e.canola"), growSpeed, {
		scale: 1.25,
		delay: 0.95 * truckWholeDuration
	}, 0.2, $.proxy(function () {

		var flowers = $(".tractor-9e.canola").find(".flower");
		// grow flowers
		this.animationTweens[anim].tweens.push(TweenMax.staggerTo(flowers, growSpeed / 2, {
			scale: 2,
			delay: 0.25, // fixes overflow issue
			ease: Back.easeOut
		}, 0.1, $.proxy(this.mainAnimationCompleted, this)));
	}, this)));

}

AnimationEngine.prototype.animateTractor9g = function (anim) {

	var density = 9;

	for (var i = 0; i < density; i++) {

		// generate crops that will be animated on truck pass
		var canola = $('<div id="tractor-9g-canola-' + i + '" class="animation tractor-9g canola"></div>');
		this.animationsContainer.append(canola);
		canola.html($('#graphics-bank svg[data-graphic-id="canola-plant"]').clone());

		var baseX = 300 + (((this.animationsContainer.width() - 300) / density) * i);

		//set the starting values
		this.animationTweens[anim].tweens.push(TweenMax.set(canola, {
			x: baseX,
			scale: 1,
			opacity: 1,
			transformOrigin: "50% bottom"
		}));

		this.animationTweens[anim].tweens.push(TweenMax.set(canola.find(".flower"), {
			scale: 0,
			transformOrigin: "center center"
		}));
	}

	var density = 10;

	for (i = 0; i < density; i++) {

		var type = (i % 3) + 1;

		var weed = $('<div id="tractor-9g-weed-' + i + '" class="animation tractor-9g weed weed-type-' + type + '"></div>');
		this.animationsContainer.append(weed);
		weed.html($('#graphics-bank svg[data-graphic-id="weed-' + type + '-medium"]').clone());

		var xPos = this.spawnWeed(weed, i, anim, density, "small", true);

		// var fume = $('<div id="tractor-9g-fume-' + i + '" class="animation tractor-9g fumes"></div>');
		// this.animationsContainer.append(fume);
		// fume.html($('#graphics-bank svg[data-graphic-id="fumes"]').clone());

		// //set the starting values
		// this.animationTweens[anim].tweens.push(TweenMax.set(fume, {
		// 	x: xPos - 25,
		// 	y: "0%",
		// 	scale: 1,
		// 	autoAlpha: 0,
		// 	transformOrigin: "50% bottom"
		// }));
	}

	// Animate truck passing from left to right, then right to left
	var truck = $('<div class="animation tractor-9g truck"></div>');
	this.animationsContainer.append(truck);
	truck.html($('#graphics-bank svg[data-graphic-id="tractor-sprayer"]').clone());

	var truckWholeDuration = 10;

	this.animationTweens[anim].tweens.push(TweenMax.set(truck, {
		left: "-32%"
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(truck, truckWholeDuration, {
		left: "102%",
		ease: Linear.easeNone
	}));

	var fumeAnimSpeed = 4;


	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-0"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.38 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-0"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9g-weed-0"), {
		className: "+=die",
		delay: 0.40 * truckWholeDuration
	}));


	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-1"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.44 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-1"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9g-weed-1"), {
		className: "+=die",
		delay: 0.46 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-2"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.50 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-2"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone,
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9g-weed-2"), {
		className: "+=die",
		delay: 0.50 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-3"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.60 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-3"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9g-weed-3"), {
		className: "+=die",
		delay: 0.59 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-4"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.64 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-4"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9g-weed-4"), {
		className: "+=die",
		delay: 0.63 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-5"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.70 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-5"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9g-weed-5"), {
		className: "+=die",
		delay: 0.70 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-6"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.76 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-6"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9g-weed-6"), {
		className: "+=die",
		delay: 0.76 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-7"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.82 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-7"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9g-weed-7"), {
		className: "+=die",
		delay: 0.82 * truckWholeDuration
	}));

	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-8"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.88 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-8"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9g-weed-8"), {
		className: "+=die",
		delay: 0.88 * truckWholeDuration
	}));

	this.animationTweens[anim].tweens.push(TweenMax.set($("#tractor-9g-weed-9"), {
		className: "+=die",
		delay: 0.90 * truckWholeDuration
	}));


	// this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-9"), fumeAnimSpeed / 2, {
	// 	y: "-50%",
	// 	autoAlpha: 1,
	// 	ease: Linear.easeNone,
	// 	delay: 0.90 * truckWholeDuration,
	// 	onComplete: $.proxy(function () {
	// 		this.animationTweens[anim].tweens.push(TweenMax.to($("#tractor-9g-fume-9"), fumeAnimSpeed / 2, {
	// 			y: "-100%",
	// 			autoAlpha: 0,
	// 			ease: Linear.easeNone
	// 		}))
	// 	}, this)
	// }));


	// grow canola
	var growSpeed = 1;

	this.animationTweens[anim].tweens.push(TweenMax.staggerTo($(".tractor-9g.canola"), growSpeed, {
		scale: 1.25,
		delay: 0.95 * truckWholeDuration
	}, 0.2, $.proxy(function () {

		var flowers = $(".tractor-9g.canola").find(".flower");
		// grow flowers
		this.animationTweens[anim].tweens.push(TweenMax.staggerTo(flowers, growSpeed / 2, {
			scale: 2,
			delay: 0.25, // fixes overflow issue
			ease: Back.easeOut
		}, 0.1, $.proxy(this.mainAnimationCompleted, this)));
	}, this)));

}

AnimationEngine.prototype.animateScreen10b = function (anim) {

	var density = 9;

	for (var i = 0; i < density; i++) {
		var type = (i % 3) + 1;

		// generate crops that will be animated on truck pass
		var canola = $('<div id="screen-10b-canola-' + i + '" class="animation screen-10b canola canola-type-' + type + '"></div>');
		this.animationsContainer.append(canola);
		canola.html($('#graphics-bank svg[data-graphic-id="canola-plant"]').clone());

		var baseX = 300 + (((this.animationsContainer.width() - 300) / density) * i);

		//set the starting values
		this.animationTweens[anim].tweens.push(TweenMax.set(canola, {
			x: baseX,
			scale: 1.25,
			opacity: 1,
			transformOrigin: "50% bottom"
		}));

		this.animationTweens[anim].tweens.push(TweenMax.set(canola.find(".flower"), {
			scale: 0,
			transformOrigin: "center center"
		}));

		var flowers = $(".screen-10b.canola:eq(0), .screen-10b.canola:eq(2), .screen-10b.canola:eq(3), .screen-10b.canola:eq(6), .screen-10b.canola:eq(8)").find(".flower");
		// grow flowers
		this.animationTweens[anim].tweens.push(TweenMax.set(flowers, {
			scale: 2
		}));
	}

	var density = 10;

	for (i = 0; i < density; i++) {

		var type = (i % 3) + 1;

		var weed = $('<div id="screen-10b-weed-' + i + '" class="animation screen-10b weed weed-type-' + type + '"></div>');
		this.animationsContainer.append(weed);
		weed.html($('#graphics-bank svg[data-graphic-id="weed-' + type + '-small"]').clone());

		this.spawnWeed(weed, i, anim, density, "small", true);
	}

	var density = 9;

	for (i = 0; i < density; i++) {

		var type = (i % 4) + 1;

		var swathedCrop = $('<div id="screen-10b-swathed-crop-' + i + '" class="animation screen-10b swathed-crop swathed-crop-type-' + type + '"></div>');
		this.animationsContainer.append(swathedCrop);
		swathedCrop.html($('#graphics-bank svg[data-graphic-id="swathed-crop-' + type + '-small"]').clone());

		this.spawnSwathedCrop(swathedCrop, i, anim, density, "small", true);
	}

	var growSpeed = 1;

	// grow weeds
	this.animationTweens[anim].tweens.push(TweenMax.set($(".screen-10b.weed"), {
		scale: 3.25
	}));

	// make the plants die
	this.animationTweens[anim].tweens.push(TweenMax.set($(".screen-10b.weed, .screen-10b.canola"), {
		className: "+=die"
	}));


	// Animate truck passing from right to left
	var truck = $('<div class="animation screen-10b truck-swather"></div>');
	this.animationsContainer.append(truck);
	truck.html($('#graphics-bank svg[data-graphic-id="tractor-swather"]').clone());

	var truckDuration = 10;

	this.animationTweens[anim].tweens.push(TweenMax.set(truck, {
		left: "-25%",
		scaleX: -1
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(truck, truckDuration, {
		left: "106%",
		ease: Linear.easeNone
	}));

	// crush the canola and weeds
	var flat = 0;
	var cropDisapearSpeed = 0.6;
	var swathedCropShowSpeed = 0.4;
	var offset = -1.3;

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-canola-0"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.36 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-swathed-crop-0"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.36 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-weed-0"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.38 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-canola-1"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.42 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-swathed-crop-1"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.42 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-weed-1"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.44 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-canola-2"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.50 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-swathed-crop-2"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.50 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-weed-2"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.50 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-canola-3"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.56 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-swathed-crop-3"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.52 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-weed-3"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.5 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-canola-4"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.64 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-swathed-crop-4"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.63 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-weed-4"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.63 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-canola-5"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.70 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-swathed-crop-5"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.70 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-weed-5"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.70 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-canola-6"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.76 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-swathed-crop-6"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.76 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-weed-6"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.76 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-canola-7"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.82 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-swathed-crop-7"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.82 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-weed-7"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.82 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-canola-8"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.88 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-swathed-crop-8"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.88 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-weed-8"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.88 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-weed-9"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.90 * truckDuration + offset
	}));

	// Animate second truck passing from left to right
	var truck2 = $('<div class="animation screen-10b truck-combine"></div>');
	this.animationsContainer.append(truck2);
	truck2.html($('#graphics-bank svg[data-graphic-id="tractor-combine"]').clone());

	var truck2WholeDuration = 10;
	var offsetTruck2 = -1.5;

	this.animationTweens[anim].tweens.push(TweenMax.set(truck2, {
		left: "-32%",
		scaleX: -1
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(truck2, truck2WholeDuration, {
		left: "102%",
		ease: Linear.easeNone,
		delay: truckDuration + 1,
		onComplete: $.proxy(this.mainAnimationCompleted, this)
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-swathed-crop-0"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.38 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-swathed-crop-1"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.44 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-swathed-crop-2"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.50 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-swathed-crop-3"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.52 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-swathed-crop-4"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.63 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-swathed-crop-5"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.70 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-swathed-crop-6"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.76 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-swathed-crop-7"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.82 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10b-swathed-crop-8"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.88 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));


}

AnimationEngine.prototype.animateScreen10d = function (anim) {

	var density = 9;

	for (var i = 0; i < density; i++) {
		var type = (i % 3) + 1;

		// generate crops that will be animated on truck pass
		var canola = $('<div id="screen-10d-canola-' + i + '" class="animation screen-10d canola canola-type-' + type + '"></div>');
		this.animationsContainer.append(canola);
		canola.html($('#graphics-bank svg[data-graphic-id="canola-plant"]').clone());

		var baseX = 300 + (((this.animationsContainer.width() - 300) / density) * i);

		//set the starting values
		this.animationTweens[anim].tweens.push(TweenMax.set(canola, {
			x: baseX,
			scale: 1.25,
			opacity: 1,
			transformOrigin: "50% bottom"
		}));

		this.animationTweens[anim].tweens.push(TweenMax.set(canola.find(".flower"), {
			scale: 0,
			transformOrigin: "center center"
		}));

		var flowers = $(".screen-10d.canola:eq(0), .screen-10d.canola:eq(2), .screen-10d.canola:eq(3), .screen-10d.canola:eq(6), .screen-10d.canola:eq(8)").find(".flower");
		// grow flowers
		this.animationTweens[anim].tweens.push(TweenMax.set(flowers, {
			scale: 2
		}));
	}

	var density = 10;

	for (i = 0; i < density; i++) {

		var type = (i % 3) + 1;

		var weed = $('<div id="screen-10d-weed-' + i + '" class="animation screen-10d weed weed-type-' + type + '"></div>');
		this.animationsContainer.append(weed);
		weed.html($('#graphics-bank svg[data-graphic-id="weed-' + type + '-medium"]').clone());

		this.spawnWeed(weed, i, anim, density, "medium", true);
	}

	var density = 9;

	for (i = 0; i < density; i++) {

		var type = (i % 4) + 1;

		var swathedCrop = $('<div id="screen-10d-swathed-crop-' + i + '" class="animation screen-10d swathed-crop swathed-crop-type-' + type + '"></div>');
		this.animationsContainer.append(swathedCrop);
		swathedCrop.html($('#graphics-bank svg[data-graphic-id="swathed-crop-' + type + '-medium"]').clone());

		this.spawnSwathedCrop(swathedCrop, i, anim, density, "medium", true);
	}

	var growSpeed = 1;

	// grow weeds
	this.animationTweens[anim].tweens.push(TweenMax.set($(".screen-10d.weed"), {
		scale: 2.25
	}));

	// make the plants die
	this.animationTweens[anim].tweens.push(TweenMax.set($(".screen-10d.weed, .screen-10d.canola"), {
		className: "+=die"
	}));


	// Animate truck passing from right to left
	var truck = $('<div class="animation screen-10d truck-swather"></div>');
	this.animationsContainer.append(truck);
	truck.html($('#graphics-bank svg[data-graphic-id="tractor-swather"]').clone());

	var truckDuration = 10;

	this.animationTweens[anim].tweens.push(TweenMax.set(truck, {
		left: "-25%",
		scaleX: -1
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(truck, truckDuration, {
		left: "106%",
		ease: Linear.easeNone
	}));

	// crush the canola and weeds
	var flat = 0;
	var cropDisapearSpeed = 0.6;
	var swathedCropShowSpeed = 0.4;
	var offset = -1.3;

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-canola-0"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.36 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-swathed-crop-0"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.36 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-weed-0"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.38 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-canola-1"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.42 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-swathed-crop-1"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.42 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-weed-1"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.44 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-canola-2"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.50 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-swathed-crop-2"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.50 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-weed-2"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.50 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-canola-3"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.56 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-swathed-crop-3"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.52 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-weed-3"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.5 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-canola-4"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.64 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-swathed-crop-4"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.63 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-weed-4"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.63 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-canola-5"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.70 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-swathed-crop-5"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.70 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-weed-5"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.70 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-canola-6"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.76 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-swathed-crop-6"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.76 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-weed-6"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.76 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-canola-7"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.82 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-swathed-crop-7"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.82 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-weed-7"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.82 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-canola-8"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.88 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-swathed-crop-8"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.88 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-weed-8"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.88 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-weed-9"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.90 * truckDuration + offset
	}));

	// Animate second truck passing from left to right
	var truck2 = $('<div class="animation screen-10d truck-combine"></div>');
	this.animationsContainer.append(truck2);
	truck2.html($('#graphics-bank svg[data-graphic-id="tractor-combine"]').clone());

	var truck2WholeDuration = 10;
	var offsetTruck2 = -1.5;

	this.animationTweens[anim].tweens.push(TweenMax.set(truck2, {
		left: "-32%",
		scaleX: -1
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(truck2, truck2WholeDuration, {
		left: "102%",
		ease: Linear.easeNone,
		delay: truckDuration + 1,
		onComplete: $.proxy(this.mainAnimationCompleted, this)
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-swathed-crop-0"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.38 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-swathed-crop-1"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.44 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-swathed-crop-2"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.50 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-swathed-crop-3"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.52 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-swathed-crop-4"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.63 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-swathed-crop-5"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.70 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-swathed-crop-6"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.76 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-swathed-crop-7"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.82 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10d-swathed-crop-8"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.88 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));


}

AnimationEngine.prototype.animateScreen10e = function (anim) {

	var density = 9;

	for (var i = 0; i < density; i++) {
		var type = (i % 3) + 1;

		// generate crops that will be animated on truck pass
		var canola = $('<div id="screen-10e-canola-' + i + '" class="animation screen-10e canola canola-type-' + type + '"></div>');
		this.animationsContainer.append(canola);
		canola.html($('#graphics-bank svg[data-graphic-id="canola-plant"]').clone());

		var baseX = 300 + (((this.animationsContainer.width() - 300) / density) * i);

		//set the starting values
		this.animationTweens[anim].tweens.push(TweenMax.set(canola, {
			x: baseX,
			scale: 1.25,
			opacity: 1,
			transformOrigin: "50% bottom"
		}));

		this.animationTweens[anim].tweens.push(TweenMax.set(canola.find(".flower"), {
			scale: 2,
			transformOrigin: "center center"
		}));
	}

	var density = 9;

	for (i = 0; i < density; i++) {

		var type = (i % 4) + 1;

		var swathedCrop = $('<div id="screen-10e-swathed-crop-' + i + '" class="animation screen-10e swathed-crop swathed-crop-type-' + type + '"></div>');
		this.animationsContainer.append(swathedCrop);
		swathedCrop.html($('#graphics-bank svg[data-graphic-id="swathed-crop-' + type + '-canola-only"]').clone());

		this.spawnSwathedCrop(swathedCrop, i, anim, density, "canola-only", true);
	}

	var growSpeed = 1;

	// make the plants die
	this.animationTweens[anim].tweens.push(TweenMax.set($(".screen-10e.canola"), {
		className: "+=die"
	}));


	// Animate truck passing from right to left
	var truck = $('<div class="animation screen-10e truck-swather"></div>');
	this.animationsContainer.append(truck);
	truck.html($('#graphics-bank svg[data-graphic-id="tractor-swather"]').clone());

	var truckDuration = 10;

	this.animationTweens[anim].tweens.push(TweenMax.set(truck, {
		left: "-25%",
		scaleX: -1
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(truck, truckDuration, {
		left: "106%",
		ease: Linear.easeNone
	}));

	// crush the canola and weeds
	var flat = 0;
	var cropDisapearSpeed = 0.6;
	var swathedCropShowSpeed = 0.4;
	var offset = -1.3;

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-canola-0"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.36 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-swathed-crop-0"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.36 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-canola-1"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.42 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-swathed-crop-1"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.42 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-canola-2"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.50 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-swathed-crop-2"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.50 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-canola-3"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.56 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-swathed-crop-3"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.52 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-canola-4"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.64 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-swathed-crop-4"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.63 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-canola-5"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.70 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-swathed-crop-5"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.70 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-canola-6"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.76 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-swathed-crop-6"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.76 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-canola-7"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.82 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-swathed-crop-7"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.82 * truckDuration + offset
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-canola-8"), cropDisapearSpeed, {
		rotationX: 90,
		delay: 0.88 * truckDuration + offset
	}));
	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-swathed-crop-8"), swathedCropShowSpeed, {
		opacity: 1,
		delay: 0.88 * truckDuration + offset
	}));


	// Animate second truck passing from left to right
	var truck2 = $('<div class="animation screen-10e truck-combine"></div>');
	this.animationsContainer.append(truck2);
	truck2.html($('#graphics-bank svg[data-graphic-id="tractor-combine"]').clone());

	var truck2WholeDuration = 10;
	var offsetTruck2 = -1.5;


	this.animationTweens[anim].tweens.push(TweenMax.set(truck2, {
		left: "-32%",
		scaleX: -1
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to(truck2, truck2WholeDuration, {
		left: "102%",
		ease: Linear.easeNone,
		delay: truckDuration + 1,
		onComplete: $.proxy(this.mainAnimationCompleted, this)
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-swathed-crop-0"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.34 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-swathed-crop-1"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.40 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-swathed-crop-2"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.50 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-swathed-crop-3"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.56 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-swathed-crop-4"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.63 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-swathed-crop-5"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.70 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-swathed-crop-6"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.76 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-swathed-crop-7"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.82 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));

	this.animationTweens[anim].tweens.push(TweenMax.to($("#screen-10e-swathed-crop-8"), swathedCropShowSpeed, {
		opacity: 0,
		delay: truckDuration + 1 + (0.88 * truck2WholeDuration) + offsetTruck2,
		immediateRender: false
	}));


}

AnimationEngine.prototype.mainAnimationCompleted = function () {
	if (typeof this.game.currentScreenData["automatic_goto"] !== "undefined") {
		this.game.gotoScreen(this.game.currentScreenData["automatic_goto"]);
	}

};

AnimationEngine.prototype.killTweens = function (removeTweens) {

	var remove = typeof removeTweens === "undefined" ? true : removeTweens;

	$.each(this.animationTweens, $.proxy(function (i, anim) {
		this.animationsContainer.find(".animation." + i + "").fadeOut("normal", $.proxy(function (i, anim) {
			for (var j = 0; j < anim.tweens.length; j++) {
				anim.tweens[j].kill();
			}

			this.animationTweens[i] = null;
			delete this.animationTweens[i];

			var index = this.activeAnimations.indexOf(i);
			if (index !== -1) {
				this.activeAnimations.splice(index, 1);
			}

			if (remove) {
				this.animationsContainer.find(".animation." + i + "").remove();
			}

		}, this, i, anim));
	}, this));
}

AnimationEngine.prototype.getGSAPBezierFromSVG = function (svg, offset) {
	var data = Snap.path.toCubic(svg.attr('d')),
		points = []; //holds our series of x/y values for anchors and control points,

	// convert cubic data to GSAP bezier
	for (var i = 0; i < data.length; i++) {
		var seg = data[i];
		if (seg[0] === "M") { // move (starts the path)
			var point = {};
			point.x = seg[1] + offset.x;
			point.y = seg[2] + offset.y;
			points.push(point);
		} else { // seg[0] === "C" (Snap.path.toCubic should return only curves after first point)
			for (var j = 1; j < 6; j += 2) {
				var point = {};
				point.x = seg[j] + offset.x;
				point.y = seg[j + 1] + offset.y;
				points.push(point);
			}
		}
	}

	return points;
};

// Expose Farmer
window.AnimationEngine = AnimationEngine;
